<script>
import axios from "axios";
import {BrandMenu, BrandsPath, MenuPath, OpsPath, StorePath} from "@/path";
import Swal from "sweetalert2";

export default {
  props : ['selectedMenu'],
  computed: {
    BrandsPath() {
      return BrandsPath
    },
    MenuPath() {
      return MenuPath
    },
    StorePath() {
      return StorePath
    }
  },
  components : {},
  data(){
    return {
      filter : [],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      menu_items : [],
      search_items : [],
      search_brand : [],
      form : {},
      fields : [{
        key: 'title',
        sortable: true
      },"actions"],
      items_fields : ["title","actions"],
      search_items_api : BrandMenu.BRAND_SEARCH_MENU,
      search : '',
      search_two : '',
      items : [],
      current_page : 1,
      current_ppage : 1,
      items_current_page: 1,
      sortDesc : false,
      options : []
    }
  },
  mounted() {
    this.getMenuOptions();
    this.getMenuItems();
    this.getItems();
  },
  watch : {
    search(){
      this.getMenuOptions();
      this.getMenuItems();
    },
    search_two(){
      this.getItems();
    },
    selectedMenu(){
      this.getMenuOptions();
      this.getMenuItems();
    },
    items_current_page(){
      this.getItems();
    },
    current_page(){
      this.getMenuItems();
    },
    current_ppage(){
      this.getMenuOptions();
    },
    sortDesc(){
      this.getMenuItems();
    }
  },
  methods : {
    async saveItem(v){
      try {
        console.log(v);
        let res = await axios.post(this.baseUrl + MenuPath.STORE_ITEMS,{
          menu_id : this.selectedMenu.id,
          items : Array.isArray(v) ? v : (typeof v == 'string' && v == 'all' ? this.menu_items.data : [v]),
        });
        if(res.data.status){
          this.$bvToast.toast('Successfully added', {
            title: `Item added`,
            variant: 'success',
            solid: true
          });
          this.getMenuOptions();
          this.getMenuItems();
          this.getItems();
        }
      }catch (e){
        console.log(e);
      }
    },
    async saveItemOptions(v){
      try {
        console.log(v);
        let res = await axios.post(this.baseUrl + MenuPath.STORE_ITEMS,{
          menu_id : this.selectedMenu.id,
          options : this.options.data
        });
        if(res.data.status){
          this.$bvToast.toast('Successfully added', {
            title: `Item added`,
            variant: 'success',
            solid: true
          });
          this.getMenuOptions();
          this.getMenuItems();
          this.getItems();
        }
      }catch (e){
        console.log(e);
      }
    },
    async deleteItem(v){
      try{
        let res = await axios.delete(this.baseUrl + MenuPath.DELETE_MENU_ITEMS,{
          params : {
            item_id : [v.id],
            menu_id : this.selectedMenu.id
          }
        });
        if(res.data.status){
          this.$bvToast.toast('Successfully removed', {
            title: `Item removed`,
            variant: 'success',
            solid: true
          });
          this.getMenuOptions();
          this.getMenuItems();
          this.getItems();
        }
      }catch (e) {
        console.log(e);
      }
    },
    async pushToUp(v){
      try {
        let res = await axios.post(this.baseUrl + MenuPath.MENU_PUSH_UP,{
          menu_id : this.selectedMenu.id,
          items_only : [v.id]
        });
        if(res.data.status){
          Swal.fire('Saved!', '', 'success');
        } 
      } catch (error) {
        console.log(error);
      }
    },
    async getItems(){
      try {
        if(this.selectedMenu != null){
          let res = await axios.get(this.baseUrl + MenuPath.GetItems,{
            params : {
              id : this.selectedMenu.id,
              search : this.search_two,
              page: this.items_current_page,
              sortDesc : this.sortDesc
            }
          });
          if(res.data.status){
            this.items = res.data.data;
          }
        }
      }catch (e){
        console.log(e);
      }
    },
    sortingChanged(v){
      this.sortDesc = v.sortDesc;
    },
    async getOps(ids){
      try {
        let res = await axios.get(this.baseUrl + OpsPath.GETOPS,{
          params : {
            ids : ids
          }
        });
        if(res.data.status){
          this.menu_items
        }
      }catch (e){
        console.log(e);
      }
    },
    async getMenuOptions(){
      try {
        let res = await axios.get(this.baseUrl + MenuPath.MENU_OPTIONS,{
          params : {
            menu_id : this.selectedMenu.id,
            page : this.current_ppage,
            search : this.search
          }
        });
        if(res.data.status){
          this.options = res.data.data;
          this.options.data = this.options.data.map((f) => {
            if(!f.menu_items){
              f.menu_items = {
                rp_price : 0,
              }
            }
            return f;
          })
        }
      }catch (e){
        console.log(e);
      }
    },
    async getMenuItems(){
      try {
        if(this.selectedMenu != null){
          let res = await axios.get(this.baseUrl + MenuPath.GetMenuItems,{
            params : {
              id : this.selectedMenu.id,
              search : this.search,
              page : this.current_page,
              sortDesc : this.sortDesc
            }
          });
          if(res.data.status){
            this.menu_items = res.data.data;

            // this.getOps(this.menu_items.map((f) => f.options_groups.map()))
          }
        }
      }catch (e){
        console.log(e);
      }
    }
  }
}
</script>

<template>
  <div class="row">
      <div class="col-12">
        <b-tabs>
          <b-tab title="Menu Items">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive mb-0">
                  <div class="pb-2 float-right w-25">
                    <b-row>
                      <b-col sm="12">
                        <b-input-group  size="sm">
                          <b-input-group-prepend is-text>
                            <i class="fa fa-search"></i>
                          </b-input-group-prepend>
                          <b-input size="sm" placeholder="Search" v-model="search"></b-input>
                        </b-input-group>
                      </b-col>
                    </b-row>
                  </div>
                  <b-tabs pills>
                    <b-tab title="Items">
                      <b-table
                          :key="menu_items.key"
                          :items="menu_items.data"
                          :fields="fields"
                          responsive="sm"
                          :filter="filter"
                          :current-page="current_page"
                          @sort-changed="sortingChanged"
                          bordered
                      >
                        <template v-slot:cell(actions)="row">
                          <b-button variant="primary" @click="pushToUp(row.item)"><i class="fa fa-upload"></i></b-button>
                          <b-button @click="deleteItem(row.item)" variant="danger" class="ml-1">
                            <i class="fa fa-trash"></i>
                          </b-button>
                        </template>
                      </b-table>
                      <div class="row">
                        <div class="col">
                          <b-button @click="saveItem('all')" variant="success" class="ml-2">
                            Save Page
                          </b-button>
                        </div>
                        <div class="col">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                              <!-- pagination -->
                              <b-pagination :key="menu_items.key" v-model="current_page" :total-rows="menu_items.total" :per-page="menu_items.per_page"></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab title="Modifiers">
                      <b-table
                          :key="options.key"
                          :items="options.data"
                          :fields="['title']"
                          responsive="sm"
                          :current-page="current_ppage"
                          borderless
                      >
                      </b-table>
                      <div class="row">
                        <div class="col">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                              <!-- pagination -->
                              <b-pagination :key="options.key" v-model="current_ppage" :total-rows="options.total" :per-page="options.per_page"></b-pagination>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <b-button @click="saveItemOptions('all')" variant="success" class="ml-1">
                          Save All
                        </b-button>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
                </div>
              </div>
          </b-tab>
          <b-tab title="Add Items">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive mb-0">
                  <div class="pb-2 float-right w-25">
                    <b-row>
                      <b-col sm="12">
                        <b-input-group  size="sm">
                          <b-input-group-prepend is-text>
                            <i class="fa fa-search"></i>
                          </b-input-group-prepend>
                          <b-input size="sm" placeholder="Search" v-model="search_two"></b-input>
                        </b-input-group>
                      </b-col>
                    </b-row>
                  </div>
                  <b-table
                      :key="items.key"
                      :items="items.data"
                      :fields="items_fields"
                      responsive="sm"
                      :filter="filter"
                      :current-page="items_current_page"
                  >
<!--                    <template v-slot:cell(brand)="row">-->
<!--                      <p>{{row.item.items[0]?.brand?.name}}</p>-->
<!--                    </template>-->
<!--                    <template v-slot:cell(markup_price)="row">-->
<!--                      <b-input type="number" v-model="row.item.items[0].markup_price"></b-input>-->
<!--                    </template>-->
                    <template v-slot:cell(actions)="row">
                      <b-button @click="saveItem(row.item)" v-b-tooltip.hover title="Add to menu" class="mr-2" variant="primary">
                        <i class="fa fa-plus-square"></i>
                      </b-button>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination :key="items.key" v-model="items_current_page" :total-rows="items.total" :per-page="items.per_page"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
</template>

<style>

</style>